import { ShaderStore } from "../../Engines/shaderStore.js";
var name = 'geometryVertexDeclaration';
var shader = "\nuniform mat4 viewProjection;\nuniform mat4 view;";
ShaderStore.IncludesShadersStore[name] = shader;
/** @hidden */
export var geometryVertexDeclaration = { name: name, shader: shader };
